export default __webpack_public_path__ + "static/media/(73).1e4dd435.jpg";